export class Clerk {
    ID: number;
    Code: string;
    Name: string;
    Inactive?: boolean;
    FullName?: string;
}

export default Clerk;